/* global deleteAllUrl */

import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';
import { Modal } from 'flowbite';

import { modalOptions } from 'Helpers/modalOptions';

import Button from 'CommonComponents/Button';
import ModalHeader from 'CommonComponents/ModalHeader';

import useApiRequest from 'Hooks/useApiRequest';

export default function DeleteActualCosts(props) {
    const [deleteActualsModalElement, setDeleteActualsModalElement] = useState(null);
    const deleteActualsModalRef = useRef();

    const deleteRequest = useApiRequest({ url: props.url });

    useEffect(() => {
        deleteActualsModalRef && setDeleteActualsModalElement(new Modal(deleteActualsModalRef.current, modalOptions(false)));
    }, []);

    const resetData = () => {
        deleteActualsModalElement && deleteActualsModalElement.hide();
    };

    const successHandler = () => {
        resetData();
    };

    const closeModal = () => {
        resetData();
    };

    const confirmDeleteActuals = () => {
        deleteActualsModalElement && deleteActualsModalElement.show();
    };

    const deleteActuals = () => {
        deleteRequest.delete().then((res) => {
            closeModal();
            window.location.reload();
        });
    };

    return (
        <>
            <Button variant="danger" onClick={confirmDeleteActuals} disabled={deleteRequest.loading}>
                {$t('Delete Actuals')}
            </Button>

            <div id="delete-actuals" ref={deleteActualsModalRef} tabIndex="-1" aria-hidden="true" className="hidden modal__box">
                <div className="modal__container">
                    <div className="modal__inner-container">
                        <ModalHeader title={$t('Delete Actuals')} close={closeModal}></ModalHeader>
                        <div className="tw-rounded-b">
                            <div className="modal__form-container">
                                <div>
                                    <span className="tw-ml-2">{$t('This action will clear all actual data from the event. Do you wish to continue?')}</span>
                                </div>
                                <div className="modal__footer">
                                    <Button variant="danger" onClick={deleteActuals} disabled={deleteRequest.loading}>
                                        {$t('Confirm')}
                                    </Button>

                                    <Button variant="secondary" onClick={closeModal}>
                                        {$t('Cancel')}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

if (document.getElementById('deleteActualCosts')) {
    var rootEl = document.getElementById('deleteActualCosts'); // data attributes below help us
    ReactDOM.render(
        <App>
            <DeleteActualCosts url={deleteAllUrl} />
        </App>,
        rootEl,
    );
}
